import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-791fb98d")

_pushScopeId("data-v-791fb98d")
const _hoisted_1 = { class: "ui__checkTitle" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 标准解读 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.titleCont) + " " + _toDisplayString(_ctx.count) + "项 ", 1),
    (!_ctx.state.reportMsg.RpCK())
      ? (_openBlock(), _createBlock("span", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick(_ctx.titleCont)))
        }, [
          _hoisted_2,
          _createVNode("img", {
            class: "arrow",
            src: require("@/assets/toc/arrowRight.png")
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true)
  ]))
})